module.exports = __webpack_public_path__ + "static/el-centinela-248ad5500c5215e0a6e0b02d38b944d3.jpg";